import Api from "../Utils/Axios";

export const GetCustomNotificationList = async (data) => {
  const response = await Api.get(
    `custom-notifications?page=${data?.page}&limit=${data?.limit}&search=${data?.search || ""}`
  );
  return response.data;
};

export const SendCustomNotification = async (data) => {
  const response = await Api.post("custom-notifications/send", data);
  return response.data;
};
